<template>
  <div class="rsvp-report-box">
    <div class="rsvp-report">
      <div class="form-group">
        <div class="instruction">Please select a start and end date:</div>
        <div class="row expanded">
          <div class="small-6 column padding-R">
            <div class="date-input">
              <label>Start Date:</label>
              <datepicker class="datepicker" v-model="from" format="MMMM dd, yyyy" :highlighted="highlightedDates"></datepicker>
            </div>
          </div>
          <div class="small-6 column padding-L">
            <div class="date-input end-date">
              <label>End Date:</label>
              <datepicker class="datepicker" v-model="to" format="MMMM dd, yyyy" :highlighted="highlightedDates"></datepicker>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="list-box">
      <div class="rsvp-report">
        <div class="form-group">
          <div class="download-type">
            <label :class="{'pdf':true, 'has-error':formatError}">
              <input type="checkbox" name="downloadType" v-model="pdfChecked"
                @click="formatCheck" />
              PDF
            </label>
            <label :class="{'csv':true, 'has-error':formatError}">
              <input type="checkbox" name="downloadType" v-model="csvChecked"
                @click="formatCheck" />
              CSV
            </label>
          </div>
          <div class="instruction">Please select the reports to generate:</div>
          <div class="row expanded reports">
            <div :class="['small-12 column report', reportStatus.lyftReport, {'processing':pdf.loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.lyftReport" />
                <span>{{ reportLabel('lyftReport') }}</span>
              </label>
            </div>
          </div>
        </div>

        <transition name="slide-down">
          <div class="error" v-show="error.show">
            <span v-show="!!error.message">{{ error.message }}</span>
            <ul v-show="error.empty.length">
              <li>Empty Result:</li>
              <li v-for="empty in error.empty">- {{ empty }}</li>
            </ul>
          </div>
        </transition>
        <a v-bind:class="{ 'button cta success small block': true, disabled: pdf.loading }"
          href="javascript:;" @click="startProcess">
          <i class="fa fa-spinner fa-spin" v-show="pdf.loading"></i>
          <span v-show="!pdf.loading">Generate and Download Report</span>
        </a>
      </div>

      <div id="pdf-view" :class="[pdf.class]">
        <div v-for="(pageData, pageIndex) in pdf.table.data" :class="['page', pageIndex]">
          <div class="title">{{ pdf.title }}</div>
          <div class="date-range">{{ pdf.date }}</div>
          <table>
            <thead>
              <tr>
                <th v-for="label in pdf.table.label" v-html="label"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in pageData">
                <td v-for="(value, i) in data" :class="[i]">{{ i == 'amount' ? parseFloat(value).toFixed(2) : value }}</td>
              </tr>

              <!-- <tr v-if="isLyftReport && currentPage(pageIndex) == totalPage + 1" class="total">
                <td class="date">Total ({{pdf.table.total.rsvp}})</td>
              </tr>
              <tr v-show="isLyftReport && currentPage(pageIndex) == totalPage + 1" class="total remove-top" v-for="(val, key) in pdf.table.total.type">
                <td class="date">{{key}} ({{val}})</td>
                <td colspan="5">
                  <span v-for="(val2, key2) in pdf.table.total.deviceType[key]" style="display:inline-block; margin-right: 10px;">
                    {{ sourceLabel(key2) }}: {{ val2 }}
                  </span>
                </td>
              </tr> -->

            </tbody>
          </table>
          <div class="page-count">page {{ currentPage(pageIndex) }} of {{ totalPage }}</div>
        </div>

        <div :class="['page', `page${totalPage + 1}`]" v-if="isLyftReport">
          <div class="title">{{ pdf.title }}</div>
          <div class="date-range">{{ pdf.date }}</div>
          <table>
            <thead>
              <tr><th colspan="8"></th></tr>
            </thead>
            <tbody>
              <tr class="total"><td colspan="8">&nbsp;</td></tr>

              <tr class="total remove-top" v-if="pdf.table.total.type.lyft">
                <td class="date" valign="top">Lyft ({{pdf.table.total.type.lyft}})</td>
                <td colspan="6">
                  <!-- <div style="padding-bottom: 10px;color:#999;font-weight: 500">Primetime ONLY Total: ${{totals.lyft.ptsOnly}}</div> -->
                  <div style="padding-bottom: 1px;">Primetime Total: ${{(totals.lyft.pts + totals.lyft.ptsOnly).toFixed(2)}}</div>
                  <div style="padding-bottom: 1px;">
                    Lyft Total:
                    <span v-if="!totals.lyft.lyft">N/A</span>
                    <span v-else>-${{totals.lyft.lyft}}</span>
                  </div>
                </td>
                <td valign="top">
                  <div style="padding-bottom: 3px;">Margin: ${{(parseFloat((totals.lyft.pts + totals.lyft.ptsOnly)) - parseFloat(totals.lyft.lyft)).toFixed(2)}}</div>
                </td>
              </tr>
              <tr class="total remove-top" v-if="pdf.table.total.type.lyft">
                <td class="date" valign="top"></td>
                <td colspan="7" style="padding-bottom: 10px">
                  <!-- <div style="padding-bottom: 5px">Total Amount: ${{pdf.table.total.amountLyft}}</div> -->
                  <span v-for="(val2, key2) in pdf.table.total.deviceType.lyft" style="display:inline-block; margin-right: 10px;font-weight:500;color:#333">
                    {{ sourceLabel(key2) }}: {{ val2 }}
                  </span>
                </td>
              </tr>
              <tr class="total remove-top" v-for="n in Math.ceil(Object.keys(pdf.table.total.brand.lyft || {}).length / 2)" v-if="pdf.table.total.brand.lyft">
                <td class="date" valign="top"></td>
                <td colspan="7">
                  <span v-if="Object.entries(pdf.table.total.brand.lyft)[(n - 1) * 2]" style="display:inline-block; margin-right: 10px;font-weight:500;color:#333">{{ Object.entries(pdf.table.total.brand.lyft)[(n - 1) * 2][0] }}: {{ Object.entries(pdf.table.total.brand.lyft)[(n - 1) * 2][1] }}</span>
                  <span v-if="Object.entries(pdf.table.total.brand.lyft)[(n * 2) - 1]" style="display:inline-block; margin-right: 10px;font-weight:500;color:#333">{{ Object.entries(pdf.table.total.brand.lyft)[(n * 2) - 1][0] }}: {{ Object.entries(pdf.table.total.brand.lyft)[(n * 2) - 1][1] }}</span>
                </td>
              </tr>

              <tr><td colspan="6">&nbsp;</td></tr>

              <tr class="total remove-top" v-if="pdf.table.total.type.farmout">
                <td class="date" valign="top">Farm out ({{pdf.table.total.type.farmout}})</td>
                <td colspan="6">
                  <!-- <div style="padding-bottom: 10px;color:#999;font-weight: 500">Primetime ONLY Total: ${{totals.lyft.ptsOnly}}</div> -->
                  <div style="padding-bottom: 1px;">Primetime Total: ${{(totals.farmout.pts + totals.farmout.ptsOnly).toFixed(2)}}</div>
                  <div style="padding-bottom: 1px;">
                    Lyft Total:
                    <span v-if="!totals.farmout.lyft">N/A</span>
                    <span v-else>-${{totals.farmout.lyft}}</span>
                  </div>
                </td>
                <td valign="top">
                  <div style="padding-bottom: 3px;">Margin: ${{(parseFloat((totals.farmout.pts + totals.farmout.ptsOnly)) - parseFloat(totals.farmout.lyft)).toFixed(2)}}</div>
                </td>
              </tr>
              <tr class="total remove-top" v-if="pdf.table.total.type.farmout">
                <td class="date" valign="top"></td>
                <td colspan="7" style="padding-bottom: 10px">
                  <!-- <div style="padding-bottom: 5px">Total Amount: ${{pdf.table.total.amountFarmout}}</div> -->
                  <span v-for="(val2, key2) in pdf.table.total.deviceType.farmout" style="display:inline-block; margin-right: 10px;font-weight:500;color:#333">
                    {{ sourceLabel(key2) }}: {{ val2 }}
                  </span>
                </td>
              </tr>
              <tr class="total remove-top" v-for="n in Math.ceil(Object.keys(pdf.table.total.brand.farmout || {}).length / 2)" v-if="pdf.table.total.brand.farmout">
                <td></td>
                <td colspan="7">
                  <span v-if="Object.entries(pdf.table.total.brand.farmout)[(n - 1) * 2]" style="display:inline-block; margin-right: 10px;font-weight:500;color:#333">{{ Object.entries(pdf.table.total.brand.farmout)[(n - 1) * 2][0] }}: {{ Object.entries(pdf.table.total.brand.farmout)[(n - 1) * 2][1] }}</span>
                  <span v-if="Object.entries(pdf.table.total.brand.farmout)[(n * 2) - 1]" style="display:inline-block; margin-right: 10px;font-weight:500;color:#333">{{ Object.entries(pdf.table.total.brand.farmout)[(n * 2) - 1][0] }}: {{ Object.entries(pdf.table.total.brand.farmout)[(n * 2) - 1][1] }}</span>
                </td>
              </tr>

              <tr class="total remove-top" v-if="pdf.table.total.type.manual">
                <td class="date" valign="top">Manual ({{pdf.table.total.type.manual}})</td>
                <td colspan="6">
                  <!-- <div style="padding-bottom: 10px;color:#999;font-weight: 500">Primetime ONLY Total: ${{totals.lyft.ptsOnly}}</div> -->
                  <div style="padding-bottom: 1px;;">Primetime Total: ${{(totals.manual.pts + totals.manual.ptsOnly).toFixed(2)}}</div>
                  <div style="padding-bottom: 1px;;">
                    Lyft Total: 
                    <span v-if="!totals.manual.lyft">N/A</span>
                    <span v-else>-${{totals.manual.lyft}}</span>
                  </div>
                </td>
                <td valign="top">
                  <div style="padding-bottom: 3px;">Margin: ${{(parseFloat((totals.manual.pts + totals.manual.ptsOnly)) - parseFloat(totals.manual.lyft)).toFixed(2)}}</div>
                </td>
              </tr>
              <tr class="total remove-top" v-if="pdf.table.total.type.manual">
                <td class="date" valign="top"></td>
                <td colspan="7" style="padding-bottom: 10px">
                  <!-- <div style="padding-bottom: 5px">Total Amount: ${{pdf.table.total.amountManual}}</div> -->
                  <span v-for="(val2, key2) in pdf.table.total.deviceType.manual" style="display:inline-block; margin-right: 10px;font-weight:500;color:#333">
                    {{ sourceLabel(key2) }}: {{ val2 }}
                  </span>
                </td>
              </tr>
              <tr class="total remove-top" v-for="n in Math.ceil(Object.keys(pdf.table.total.brand.manual || {}).length / 2)" v-if="pdf.table.total.brand.manual">
                <td></td>
                <td colspan="7">
                  <span v-if="Object.entries(pdf.table.total.brand.manual)[(n - 1) * 2]" style="display:inline-block; margin-right: 10px;font-weight:500;color:#333">{{ Object.entries(pdf.table.total.brand.manual)[(n - 1) * 2][0] }}: {{ Object.entries(pdf.table.total.brand.manual)[(n - 1) * 2][1] }}</span>
                  <span v-if="Object.entries(pdf.table.total.brand.manual)[(n * 2) - 1]" style="display:inline-block; margin-right: 10px;font-weight:500;color:#333">{{ Object.entries(pdf.table.total.brand.manual)[(n * 2) - 1][0] }}: {{ Object.entries(pdf.table.total.brand.manual)[(n * 2) - 1][1] }}</span>
                </td>
              </tr>

              <tr><td colspan="6">&nbsp;</td></tr>

              <tr class="total remove-top">
                <td class="date">Total ({{pdf.table.total.rsvp}})</td>
                <td colspan="6">Primetime Total: ${{pdf.table.total.amount.toFixed(2)}}</td>
                <td valign="top">Total Margin: ${{(parseFloat(pdf.table.total.amount) - parseFloat(pdf.table.total.lyftPrice)).toFixed(2)}}</td>
              </tr>
              <tr class="total remove-top">
                <td class="date"></td>
                <td colspan="7">Lyft Total: -${{pdf.table.total.lyftPrice.toFixed(2)}}</td>
              </tr>

            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import datepicker from 'vuejs-datepicker'
import CsvExport from 'csvexport'

export default {
  name: 'trx-report',
  components: { datepicker },
  data () {
    return {
      from: null,
      to: null,
      error: {
        show: false,
        message: '',
        empty: []
      },
      selectedReports: {
        lyftReport: true
      },
      reportStatus: {
        lyftReport: ''
      },
      pdf: {
        code: '',
        class: '',
        title: '',
        date: '',
        table: {
          label: [],
          data: {},
          extra: {},
          total: {}
        },
        maxRecordPerPage: 40,
        list: [],
        current: '',
        loading: false
      },
      orientation: ['lyftReport'],
      nonCompletedChecked: true,
      purchasedChecked: true,
      canceledChecked: true,
      pdfChecked: true,
      csvChecked: false,
      formatError: false,
      csv: {
        label: [],
        data: [],
        list: [],
        total: {}
      },
      isIOS: navigator.userAgent.match(/(iPad|iPhone|iPod)/g),
      totals: {
        lyft: {
          ptsOnly: 0,
          pts: 0,
          lyft: 0
        },
        farmout: {
          ptsOnly: 0,
          pts: 0,
          lyft: 0
        },
        manual: {
          ptsOnly: 0,
          pts: 0,
          lyft: 0
        }
      }
    }
  },
  computed: {
    show () { return this.$store.state.reports.rsvpReport.show },
    highlightedDates () {
      let self = this
      let result = { to: null, from: null }

      if (self.from !== null) { result.from = self.from }
      if (self.to !== null) { result.to = self.to }
      return result
    },
    totalPage () { return Object.keys(this.pdf.table.data).length },
    isLyftReport () { return this.pdf.code === 'lyftReport' && this.totalPage }
  },
  methods: {
    isValid () {
      let self = this
      self.error.show = false
      self.error.empty = []
      if (self.from === null || self.to === null) {
        self.error.show = true
        self.error.message = 'Please specify the Start and End dates.'
        return false
      }

      let from = moment(self.from)
      let to = moment(self.to)

      if (from.isAfter(to)) {
        self.error.show = true
        self.error.message = 'End date must be after Start date.'
        return false
      }

      self.formatError = false
      if (!self.pdfChecked && !self.csvChecked) {
        self.error.show = true
        self.error.message = 'Please select which file format.'
        self.formatError = true
        return false
      }

      if (!self.selectedReports.lyftReport) {
        self.error.show = true
        self.error.message = 'Please select at least one report type.'
        return false
      }

      return true;
    },
    getNewDoc () {
      let doc = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'a4'
      })
      doc.setFont('helvetica')
      return doc
    },
    startProcess () {
      if (!this.isValid()) { return }

      this.pdf.list = []
      this.csv.list = []
      for (let report in this.selectedReports) {
        if (this.selectedReports[report]) {
          this.reportStatus[report] = 'on-queue'
          this.pdf.list.push(report)
          this.csv.list.push(report)
        }
      }

      this.totals = {
        lyft: {
          ptsOnly: 0,
          pts: 0,
          lyft: 0
        },
        farmout: {
          ptsOnly: 0,
          pts: 0,
          lyft: 0
        },
        manual: {
          ptsOnly: 0,
          pts: 0,
          lyft: 0
        }
      }

      this.pdf.loading = true
      this.generateReport()
    },
    generateReport (isCsv = false) {
      if (((!this.pdf.list.length && this.pdfChecked) || !this.pdfChecked) &&
        ((!this.csv.list.length && this.csvChecked) || !this.csvChecked)
      ) {
        this.pdf.loading = false
        return
      }

      if (isCsv) {
        console.log('Processing:', this.csv.list[0])
        this.getDataReports(this.csv.list[0])
      } else {
        console.log('Processing:', this.pdf.list[0])
        this.getDataReports(this.pdf.list[0])
      }
    },
    getDataReports (type) {
      let self = this
      self.reportStatus[type] = 'loading'
      let orientationMax = self.orientation
      self.pdf.maxRecordPerPage = orientationMax.indexOf(type) > -1 ? 25 : 40
      self.$sdk.get(self.apiParams(type).url, self.apiParams(type).data, r => {
        if (r.error) {
          self.reportStatus[type] = 'has-error'
          return
        }

        self.setPdfLabel(type)
        self.pdf.table.data = {}
        self.pdf.table.extra = {}
        self.pdf.table.total = {}
        self.csv.data = []
        self.csv.total = {}

        if (r.list.length > 0) {
          self.buildPdfData(type, r.list)
        } else {
          self.error.show = true
          self.error.empty.push(self.reportLabel(type))
          self.reportStatus[type] = 'has-error'
          self.pdf.list.shift()
          self.csv.list.shift()
          self.generateReport()
        }
      })
    },
    apiParams (type) {
      /*
        -----   Refference   -----
        lyftReport          NEW
      */

      let url = ''
      let start = moment(this.from)
      let end = moment(this.to)
      let data = {
        token: this.$store.state.session.sessionToken,
        since: start.format('YYYY-MM-DD'),
        until: end.format('YYYY-MM-DD')
      }

      switch (type) {
        case 'lyftReport':
          url = '/reports/lyft/summary'
          break
      }

      return { url: url, data: data }
    },
    setPdfLabel (type) {
      let start = moment(this.from)
      let end = moment(this.to)
      let dateRange = start.format('MM/DD/YYYY') + ' - ' + end.format('MM/DD/YYYY')

      this.pdf.code = type
      if (type === 'lyftReport') {
        this.pdf.class = 'trx-summary'
        this.pdf.title = 'Lyft Report'
        this.pdf.date = dateRange
        this.pdf.table.label = [
          'Pickup Date/Time', 'RSVP ID', 'Type', 'Brand', 'Amount', 'Lyft Price', 'Pickup', 'Dropoff', 'Source'
        ]
      }
    },
    buildPdfData (type, pdfData) {
      let self = this
      let groupCount = 0
      let page = 1

      // lyftReport
      let totalRsvp = 0
      let totalAmount = 0
      let totalLyftPrice = 0
      let totalAmountLyft = 0
      let totalAmountFarmout = 0
      let totalAmountManual = 0
      let totalDeviceType = {}
      let totalType = {}
      let totalBrand = {}

      totalRsvp = pdfData.length

      if (type === 'lyftReport') {
        pdfData.sort((a, b) => a.pickupTime - b.pickupTime)
      }

      pdfData.forEach(function (data, index) {
        if (!self.pdf.table.data['page' + page]) {
          self.pdf.table.data['page' + page] = []
        }

        self.pdf.table.data['page' + page].push(self.buildTableData(type, data))
        if (self.csvChecked) {
          self.csv.data.push(self.buildCsvData(type, data))
        }
        groupCount++

        if (type === 'lyftReport') {
          data.amount = parseFloat(data.amount)
          if (!totalDeviceType[data.type]) totalDeviceType[data.type] = {}
          if (!totalDeviceType[data.type][data.deviceType]) totalDeviceType[data.type][data.deviceType] = 0
          totalDeviceType[data.type][data.deviceType]++
          
          if (!totalType[data.type]) totalType[data.type] = 0
          totalType[data.type]++

          if (data.type === 'lyft') {
            totalAmountLyft += parseFloat(data.amount.toFixed(2))
            if (!data.lyftPrice) {
              self.totals.lyft.ptsOnly += parseFloat(data.amount.toFixed(2))
            } else {
              self.totals.lyft.pts += parseFloat(data.amount.toFixed(2))
              self.totals.lyft.lyft += parseFloat(data.lyftPrice.toFixed(2))
            }
            self.totals.lyft.ptsOnly = parseFloat(self.totals.lyft.ptsOnly.toFixed(2))
            self.totals.lyft.pts = parseFloat(self.totals.lyft.pts.toFixed(2))
            self.totals.lyft.lyft = parseFloat(self.totals.lyft.lyft.toFixed(2))
          }
          if (data.type === 'farmout') {
            totalAmountFarmout += parseFloat(data.amount.toFixed(2))
            if (!data.lyftPrice) {
              self.totals.farmout.ptsOnly += parseFloat(data.amount.toFixed(2))
            } else {
              self.totals.farmout.pts += parseFloat(data.amount.toFixed(2))
              self.totals.farmout.lyft += parseFloat(data.lyftPrice.toFixed(2))
            }
            self.totals.farmout.ptsOnly = parseFloat(self.totals.farmout.ptsOnly.toFixed(2))
            self.totals.farmout.pts = parseFloat(self.totals.farmout.pts.toFixed(2))
            self.totals.farmout.lyft = parseFloat(self.totals.farmout.lyft.toFixed(2))
          }
          if (data.type === 'manual') {
            totalAmountManual += parseFloat(data.amount.toFixed(2))
            if (!data.lyftPrice) {
              self.totals.manual.ptsOnly += parseFloat(data.amount.toFixed(2))
            } else {
              self.totals.manual.pts += parseFloat(data.amount.toFixed(2))
              self.totals.manual.lyft += parseFloat(data.lyftPrice.toFixed(2))
            }
            self.totals.manual.ptsOnly = parseFloat(self.totals.manual.ptsOnly.toFixed(2))
            self.totals.manual.pts = parseFloat(self.totals.manual.pts.toFixed(2))
            self.totals.manual.lyft = parseFloat(self.totals.manual.lyft.toFixed(2))
          }

          if (!totalBrand[data.type]) totalBrand[data.type] = {}
          if (!totalBrand[data.type][self.brandName(data.brandId)]) totalBrand[data.type][self.brandName(data.brandId)] = 0
          totalBrand[data.type][self.brandName(data.brandId)]++

          if (data.amount) totalAmount += parseFloat(data.amount.toFixed(2))
          if (data.lyftPrice) totalLyftPrice += parseFloat(data.lyftPrice.toFixed(2))
        }

        if ((index + 1) % self.pdf.maxRecordPerPage === 0 && pdfData.length !== index + 1) { page++ }
      })

      self.pdf.table.total.record = pdfData.length
      if (type === 'lyftReport') {
        self.pdf.table.total.rsvp = self.covertNumber(totalRsvp)
        self.pdf.table.total.type = totalType
        self.pdf.table.total.deviceType = totalDeviceType
        self.pdf.table.total.brand = totalBrand
        self.pdf.table.total.amount = parseFloat(totalAmount.toFixed(2))
        self.pdf.table.total.lyftPrice = parseFloat(totalLyftPrice.toFixed(2))
        self.pdf.table.total.amountLyft = parseFloat(totalAmountLyft.toFixed(2))
        self.pdf.table.total.amountFarmout = parseFloat(totalAmountFarmout.toFixed(2))
        self.pdf.table.total.amountManual = parseFloat(totalAmountManual.toFixed(2))
      }

      if (self.pdfChecked) {
        self.processDownloads('pdf', {type: type, page: page})
      } else {
        self.processDownloads('csv', {type: type})
      }
      // self.processPdf(type, page)
    },
    buildTableData (type, data) {
      let self = this
      if (type === 'lyftReport') {
        // let netTotal = parseFloat(data.chargedAmount) - parseFloat(data.refundAmount)
        data.amount = parseFloat(data.amount)
        return {
          date: moment(data.pickupTime, 'X').format('MM/DD/YYYY hh:mmA'),
          rsvpId: data.rsvpId,
          type: data.type,
          brand: self.brandName(data.brandId),
          amount: data.amount ? parseFloat(data.amount.toFixed(2)) : 0,
          lyftPrice: data.lyftPrice ? parseFloat(data.lyftPrice.toFixed(2)) : 'N/A',
          pickup: data.pickup,
          dropoff: data.dropoff,
          source: self.sourceLabel(data.deviceType),
          // rideId: data.rideId
        }
      }

    },
    fileName (type, format) {
      let timestamp = moment(this.from).format('YYYYMMDD') + '_' + moment(this.to).format('YYYYMMDD')
      switch (type) {
        case 'lyftReport': return 'lyftReport_' + timestamp + '.' + format
      }
    },
    currentPage (page) { return page.substring(4) },
    processPdf (type, page) {
      let self = this
      let start = moment(self.from)
      let end = moment(self.to)
      let pageAsyncs  = []
      let landscapeReports = self.orientation
      let orientation = landscapeReports.indexOf(type) > -1 ? 'l' : 'p'
      let pdf = new jsPDF({ orientation: orientation, unit: 'mm', format: 'a4' })

      window.scrollTo(500, 0)
      document.body.style.overflow = 'hidden'

      if (type === 'lyftReport') { page++ }

      setTimeout(() => {
        // if (self.isIOS) page = page + 1
        // for (let i = 0; i < page; i++) {
        //   // self.pdf.current = 'page' + (i + 1)
        //   pageAsyncs.push(html2canvas(document.getElementsByClassName('page' + (i + 1))[0], {
        //     scale: "1"
        //   }).then(canvas => {
        //     let imgData = canvas.toDataURL('image/png', 1.0)
        //     pdf.addImage(imgData, 'PNG', 0, 0)
        //     if (i + 1 !== page) { pdf.addPage() }
        //   }).catch(e => {
        //     self.reportStatus[type] = 'has-error'
        //     self.pdf.list.shift()
        //     document.body.style.overflow = 'auto'
        //     self.processDownloads('csv', {type: type})
        //     console.warn(e)
        //   }))
        // }

        var i = 0
        var buildPdfPages = (i) => {
          if (i + 1 > page) {
            downloadPdfPages()
            return
          }
          pageAsyncs.push(html2canvas(document.getElementsByClassName('page' + (i + 1))[0], {
            scale: "1"
          }).then(canvas => {
            let imgData = canvas.toDataURL('image/jpeg', 1.0)
            pdf.addImage(imgData, 'JPEG', 0, 0)
            if (i + 1 <= page) {
              pdf.addPage()
              buildPdfPages(i + 1)
            }
          }).catch(e => {
            self.reportStatus[type] = 'has-error'
            self.pdf.list.shift()
            document.body.style.overflow = 'auto'
            self.processDownloads('csv', {type: type})
            console.warn(e)
          }))
        }
        buildPdfPages(0)

        var downloadPdfPages = () => {
          pdf.save(self.fileName(type, 'pdf'))
          self.reportStatus[type] = 'success'
          self.pdf.list.shift()
          document.body.style.overflow = 'auto'
          self.processDownloads('csv', {type: type})
        }

        // Promise.all(pageAsyncs).then(() => {
        //   let timestamp = start.format('YYYYMMDD') + '_' + end.format('YYYYMMDD')
        //   pdf.save(self.fileName(type, 'pdf'))
        //   self.reportStatus[type] = 'success'
        //   self.pdf.list.shift()
        //   document.body.style.overflow = 'auto'
        //   self.processDownloads('csv', {type: type})
        // })
      }, 500)
    },
    covertNumber (value) { return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") },
    resetSelectedStatus () {
      this.selectedReports = { lyftReport: false }
    },
    resetReportStatus () {
      this.error.show = false
      this.error.empty = []
      this.reportStatus = { lyftReport: '' }
    },
    reportLabel (type) {
      switch (type) {
        case 'lyftReport': return 'Lyft Report'
      }
    },
    buildCsvData (type, data) {
      let column = []
      this.pdf.table.label.forEach(function(i) {
        column.push(i.replace('<br/>', ''))
      })
      this.csv.label = column

      let csvData = {}
      let pdfData = this.buildTableData(type, data)

      let i = 0
      for (var key in pdfData) {
        csvData[column[i]] = pdfData[key]
        i++
      }
      return csvData
    },
    processDownloads (action, data) {
      if (action === 'pdf' && this.pdfChecked) {
        this.processPdf(data.type, data.page)
      } else if (action === 'csv' && this.csvChecked) {
        this.processCsv(data.type)
      } else {
        this.generateReport()
      }
    },
    processCsv (type) {
      const exporter = CsvExport.create({
        filename: this.fileName(type, 'csv'),
        columns: this.csv.label
      })

      // add total
      if (type === 'lyftReport') {
        this.csv.data.push(...this.buildCsvTotal(type))
      } else {
        this.csv.data.push(this.buildCsvTotal(type))
      }

      exporter.downloadCsv(this.csv.data)
      this.reportStatus[type] = 'success'
      this.csv.list.shift()

      this.generateReport(true)
    },
    buildCsvTotal (type) {
      let self = this
      let csvData = {}
      let totalData = this.pdf.table.total

      if (type === 'lyftReport') {
        csvData = []

        for (const [key, value] of Object.entries(totalData.type)) {
          let i = 0
          let row = {}
          csvData.push({})
          row[this.csv.label[i]] = `${key} (${value})`
          let tmpAmount = {} 
          if (key === 'lyft') {
            // row[this.csv.label[1]] = `Total Lyft Amount: $${totalData.amountLyft}`
            row[this.csv.label[1]] = `Primetime Total: $${(self.totals.lyft.pts + self.totals.lyft.ptsOnly).toFixed(2)}`
            row[this.csv.label[2]] = `Lyft Total: $${self.totals.lyft.lyft}`
            row[this.csv.label[3]] = `Margin: $${((self.totals.lyft.pts + self.totals.lyft.ptsOnly) - self.totals.lyft.lyft).toFixed(2)}`
            csvData.push(row)
            row = {}
          }
          if (key === 'farmout') {
            // row[this.csv.label[1]] = `Total Farm out Amount: $${totalData.amountFarmout}`
            row[this.csv.label[1]] = `Primetime Total: $${(self.totals.farmout.pts + self.totals.farmout.ptsOnly).toFixed(2)}`
            row[this.csv.label[2]] = `Lyft Total: $${self.totals.farmout.lyft}`
            row[this.csv.label[3]] = `Margin: $${((self.totals.farmout.pts + self.totals.farmout.ptsOnly) - self.totals.farmout.lyft).toFixed(2)}`
            csvData.push(row)
            row = {}
          }
          if (key === 'manual') {
            // row[this.csv.label[1]] = `Total Manual Amount: $${totalData.amountManual}`
            row[this.csv.label[1]] = `Primetime Total: $${(self.totals.manual.pts + self.totals.manual.ptsOnly).toFixed(2)}`
            row[this.csv.label[2]] = `Lyft Total: $${self.totals.manual.lyft}`
            row[this.csv.label[3]] = `Margin: $${((self.totals.manual.pts + self.totals.manual.ptsOnly) - self.totals.manual.lyft).toFixed(2)}`
            csvData.push(row)
            row = {}
          }
          for (const [key2, value2] of Object.entries(totalData.deviceType[key])) {
            i++
            row[this.csv.label[i]] = `${key2}: ${value2}`
          }
          csvData.push(row)

          let brandX = 1
          for (const [key3, value3] of Object.entries(totalData.brand[key])) {
            let brandRow = {}
            brandRow[this.csv.label[0]] = ''
            brandRow[this.csv.label[1]] = `${key3} (${value3})`
            csvData.push(brandRow)
            brandX++
          }
        }

        let csvRow1 = {}
        csvRow1[this.csv.label[0]] = `Total (${totalData.rsvp})`
        csvRow1[this.csv.label[1]] = `Primetime Total $${totalData.amount}`
        csvRow1[this.csv.label[2]] = `Lyft Total -$${totalData.lyftPrice}`
        csvRow1[this.csv.label[3]] = `Total Margin $${(parseFloat(totalData.amount) - parseFloat(totalData.lyftPrice)).toFixed(2)}`
        csvData.push(csvRow1)
      }

      return csvData
      // this.pdf.table.total
    },
    formatCheck () {
      this.error.show = false
      this.formatError = false
    },
    brandName (brandId) {
      let i = CONFIG.brands.findIndex(x => x.id === brandId)
      if (i === -1) { return brandId }

      return CONFIG.brands[i].name
    },
    sourceLabel (x) {
      if (x === 'ww') return 'web'
      return x
    }
  },
  watch: {
    show (value) {
      if (!value) { return }

      this.from = null
      this.to = null
      this.error.show = false
      this.error.empty = []

      this.resetSelectedStatus()
      this.resetReportStatus()
    },
    from (value) { this.resetReportStatus() },
    to (value) { this.resetReportStatus() },
    'selectedReports.lyftReport' (value) { this.resetReportStatus() }
  }
}
</script>

<style lang="scss" scoped>
.rsvp-report-box {
  transform-origin: top center;
  position: relative;
  width: 100%;
}
.rsvp-report {
  border-radius: 3px;
  padding: 0 20px 20px;

  & .title {
    text-align: center;
    font-weight: 700;
    margin-bottom: 20px;
    font-size: 18px;
  }

  & .date-input {
    margin-bottom: 10px;

    & label {
      font-size: 13px;
      color: #999;
      display: block;
    }
    select{
      padding: 10px;
      height: 46px;
      outline: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      border-color: #cacaca;
      font-size: 14px;
      color: #333;
      background-image: url('/assets/img/dropdown-arrow.png');
      background-repeat: no-repeat;
      background-position: right 50%;

      &[disabled]{ background-color: #ebebe4; }
    }
  }

  .reports{
    max-height: 350px;
    margin-bottom: 10px;
    overflow: auto;
    clear: both;
    background: #fafafa;
    border: 1px solid #ddd;
    position: relative;

    .report{
      position: relative;
      z-index: 1;

      &:hover{ background:#f1f1f1; }
      &.processing{
        background: rgba(0,0,0, .7);
        input{ opacity: .5; }
      }
      select{
        margin-left: 28px;
        margin-bottom: 10px;
        width: calc(100% - 43px);
        border-color: #999;
        font-size: 13px;
        color: #333;
        padding: 3px 5px;
        transition: all .2s ease;

        &.disabled{
          background: #fafafa;
          border-color: #ccc;
        }
        option:disabled{ background: #eaeaea; }
      }
      &.on-queue, &.loading, &.has-error, &.success{
        z-index: 3;
        box-shadow: 0 0 2px rgba(0,0,0, .4);
      }
      &.on-queue{ background: #fff; }
      &.loading{
        color: #775913;
        background: #f1ce7e;
      }
      &.success{
        color: #0f693a;
        background: #a9f7ce;
      }
      &.has-error{
        color: #b93030;
        background: #fbb0b0;
      }
    }
  }
}

.filter{
  list-style: none;
  margin: 0 0 5px;
  padding: 0;
  font-size: 13px;
  display: flex;

  li{
    margin: 2px 0;
    width: 100%;
  }
  label{ cursor: pointer;}
  input{
    display: inline-block;
    margin: 0 3px 0 0;
    width: auto;
    vertical-align: middle;
  }
}

.download-type{
  float: right;
  width: 150px;
  text-align: right;
  padding-bottom: 5px;

  label{
    cursor: pointer;
    display: inline-block;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    padding: 2px 7px;
    border:1px solid #ddd;

    &.pdf{ color: #c54d4d; }
    &.csv{ color: #7ad275; }
    &.has-error{ border: 1px solid #d00; }
    input{
      display: inline;
      margin-top: 0;
      width: auto;
      vertical-align: -1px;
    }
  }
}

.list-box{
  overflow: hidden;
  position: relative;
  padding-bottom: 20px;
}

.error {
  background-color: #F25E0D;
  font-size: 14px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  padding: 5px;
  margin-bottom: 15px;
  transform-origin: top center;

  ul{
    list-style: none;
    margin: 0;
    padding: 10px;
    text-align: left;

    li:first-child{
      font-weight: 600;
      font-size: 14px;
      line-height: 1;
      margin-bottom: 2px;
    }
    li{
      font-size: 13px;
    }
  }
}

.form-group {
  display: block;

  & .instruction {
    margin-bottom: 5px;
    font-size: 14px;
    font-weight: 600;
    color: #777;
  }
}

.checkbox {
  display: block;
  font-size: 13px;
  cursor: pointer;
  padding: 5px 10px;
  & > * {
    display: inline-block;
    vertical-align: middle;
    margin: 0;
    width: auto;
  }
  input { margin-right: 3px; }
}
.padding-R { padding-right: 7px; }
.padding-L { padding-left: 7px; }

#pdf-view{
  position: absolute;
  top: 100%;
  left: 0;
  width: 793px;
  height: 1122px;
  background: #fff;

  .page{
    padding: 30px;
    position: relative;
    width: 100%;
    height: 100%;

    .page-count{
      position: absolute;
      bottom: 10px;
      right: 30px;
      color: #aaa;
      font-size: 12px;
      text-align: right;
      font-style: italic;
    }
  }
  .title{
    text-align: center;
    font-weight: 600;
    font-size: 21px;
  }
  .date-range{
    text-align: center;
    font-style: italic;
    font-size: 18px;
    margin-bottom: 20px;
    color: #555;
  }

  table{
    width: 100%;
    font-size: 12px;
    border-collapse: collapse;

    thead{
      font-weight: 600;
      tr:last-child th{ border-bottom: 1px solid #333; }
    }
    tbody{
      tr{
        &.subtotal, &.total{ font-weight: 600; }
        &.total{
          color: #000;
          font-size: 14px;
        }
      }
      td{ padding: 2px 3px; }
    }
  }
}

.trx-summary{
  width: 1122px!important;
  height: 793px!important;
  // height: 1122px!important;
  // width: 793px!important;
  table{
    tbody tr.total:not(.remove-top){ border-top: 1px solid #333; }
    .date, .rsvpId, .type, .brand, .source, .rideId, .amount, .lyftPrice, .pickup, .dropoff{ text-align: center; }
    .pickup, .dropoff{
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 250px;
    }
  }
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .end-date {
    /deep/ .vdp-datepicker__calendar {
      right: 1px;
    }
  }

  .filter {
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Reports/LyftReport.vue